var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M37.3213 0C50.0238 0 60.3213 10.2975 60.3213 23V37C60.3213 49.7025 50.0238 60 37.3213 60H23.3213C10.6187 60 0.321289 49.7025 0.321289 37V23C0.321289 10.2975 10.6187 0 23.3213 0H37.3213Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M38.321 24.667C40.5302 24.667 42.321 26.4579 42.321 28.667C42.3209 30.876 40.5301 32.667 38.321 32.667C36.1122 32.6668 34.3212 30.8759 34.321 28.667C34.321 26.458 36.1121 24.6672 38.321 24.667ZM26.321 18C29.2665 18 31.6549 20.3876 31.655 23.333C31.655 26.2785 29.2666 28.667 26.321 28.667C23.3757 28.6668 20.988 26.2784 20.988 23.333C20.9882 20.3877 23.3758 18.0002 26.321 18Z",
    fill: "#8280FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2987 31.3333C32.6824 31.3333 37.9274 34.3907 38.3183 40.9329C38.3338 41.1935 38.3179 42.0002 37.3163 42.0002H15.2909C14.9564 41.9998 14.294 41.2784 14.3222 40.9319C14.8391 34.5686 20.0037 31.3333 26.2987 31.3333ZM37.7909 34.0022C42.3322 34.0523 46.0402 36.3478 46.3192 41.2004C46.3304 41.3964 46.3185 41.9998 45.5966 42.0002H40.455C40.4549 38.9998 39.4636 36.2302 37.7909 34.0022Z",
    fill: "#8280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.96e836303f43689d37c594a1a72748aa.svg";
export { ForwardRef as ReactComponent };